import { MenuItem, Select, Stack, Typography } from "@mui/material";
import React from "react";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { isLinearSettings } from "../../../../viewer/chart/helper.ts";
import { getValueAxisType } from "../../../../viewer/chart/style/serie/getValueAxisType.ts";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import type {
  ChartStyleSettings,
  SeriesSettings,
  ValueAxisType,
} from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  settings: ChartStyleSettings;
  serie: SeriesSettings;
  readonlyMode: boolean;
}

export default function SerieValueAxis({ settings, serie, readonlyMode }: Props) {
  const supported = isLinearSettings(settings);
  const valueAxisType = getValueAxisType(serie);
  const dispatch = useAppDispatch();

  const handleLineTypeChanged = React.useCallback(
    (value: ValueAxisType) =>
      dispatch(fieldsStateActions.updateSeriesSettings({ name: serie.name, changes: { valueAxis: value } })),
    [dispatch, serie]
  );

  if (!supported) {
    return <></>;
  }

  return (
    <Stack direction="row" sx={{ alignItems: "center" }}>
      <Typography sx={{ color: "text.secondary" }}>Value Axis</Typography>
      <HorizontalFill />
      <Select
        value={valueAxisType}
        sx={{ width: 200, ".MuiSelect-select": { py: 0.7, fontSize: 13 } }}
        disabled={readonlyMode}
        onChange={(evt) => handleLineTypeChanged(evt.target.value as ValueAxisType)}
      >
        <MenuItem value={"Main"} sx={{ fontSize: 13 }}>
          Main(left)
        </MenuItem>
        <MenuItem value={"Secondary"} sx={{ fontSize: 13 }}>
          Secondary(right)
        </MenuItem>
      </Select>
    </Stack>
  );
}
